<template lang="html">

  <section class="main-view">
    <div class="container-scroller">
      <app-header v-if="conTemplate" />
      <div v-bind:class="{ 'page-body-wrapper': conTemplate, 'container-fluid': conTemplate }" >
        <app-sidebar v-if="conTemplate && !headerAdmin"/>
        <app-sidebar-admin v-if="conTemplate && headerAdmin" />
        <div v-bind:class="{ 'main-panel': conTemplate}">
          <div class="content-wrapper" v-bind:class="{ 'fixHeight': !conTemplate }" :style="style">
            <p></p>
            <skeleton v-if="cargando_componente"></skeleton>
            <router-view v-else></router-view>
          </div>
          <!-- content wrapper ends -->
          <app-footer v-if="conTemplate" />
        </div>
        <!-- main panel ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </section>

</template>

<script lang="js">
import {mapGetters} from 'vuex'
import AppHeader from '@/components/partials/AppHeader'
import AppSidebarAdmin from '@/components/partials/AppSidebarAdmin'
import AppSidebar from '@/components/partials/AppSidebar'
import AppFooter from '@/components/partials/AppFooter'
import skeleton from '@/componentes/cargando/skeleton'
export default {
  name: 'principal',
  components: {
    AppHeader,
    AppSidebarAdmin,
    AppSidebar,
    AppFooter,
    skeleton,
  },
  computed: {
    ...mapGetters(['cargando_componente']),
    style () {
    //   let r = this.$route
    //   console.log(r);
    //   let secc = ['plan_bienestar_paciente','paciente_editar', 'Casos', 'ServiciosCasos'/*,'paciente_nuevo'*/]
    //   if (secc.includes(r.name)) {
    //     return  'margin-top:40px'
    //   }
    //    return ''
    },
    conTemplate(){
      if(this.$route.path == "/board"){
        return false;
      }
      return true
    },
    headerAdmin(){
      if(this.$route.path == "/panel" 
      || this.$route.path == "/empleados" 
      || this.$route.name == "empleado"
      || this.$route.name == "cliente"
      || this.$route.path == "/empleado" 
      || this.$route.name == "panel_sucursales"
      || this.$route.path == "/panel_roles"
      || this.$route.path == "/panel_rol"
      || this.$route.name == "panel_rol"
      ){
        return true;
      }
      return false
    }
    
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/mainView.vue